import React, { useEffect, useState } from 'react'
import { Route, Routes } from "react-router-dom";
import routers from './Router'

interface ICommonPageProps {
    component: React.ComponentType<any>;
}

// 如果后期需要添加一下公用的方法，
const CommonPage = (props: ICommonPageProps) => {
    const C = props.component;
    return (
        <div style={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <C {...props} />
        </div>
    )
}

const MainRouter = () => {
    return (
        <Routes>
            {
                routers.map((item, index) => {
                    return (
                        <Route
                            key={index}
                            path={item.path}
                            element={<CommonPage component={item.component} />
                            } />
                    )
                })
            }
            {/* <Route path='*' element={
                <Navigate to="/home" replace/>
            }/> */}
        </Routes>
    )
}
const App = () => {

    return (
        <MainRouter />
    )
};

export default App;

